import styles from './VerticalSystemCarousel.module.scss';

import React, { FC, useRef, useState } from 'react';
import { useVerticalSystemContext } from '../VerticalSystemContext/VerticalSystemContext';
import { VerticalSystemModal } from '../VerticalSystemModal/VerticalSystemModal';
import {
  VerticalSystemTabPanel,
  VerticalSystemTabPanelProps,
} from '../VerticalSystemTabPanel/VerticalSystemTabPanel';
import { VerticalSystemVariant } from '../types';
import { useLinkArrowAnimation } from '../useLinkArrowAnimation';
import { useVerticalSystemCarouselScroll } from './useVerticalSystemCarouselScroll';

type VerticalSystemCarouselProps = Omit<VerticalSystemTabPanelProps, 'isTabActive' | 'styles' | 'tabItem'>;

export const VerticalSystemCarousel: FC<VerticalSystemCarouselProps> = props => {
  const { tabItems, activeTabItem, setActiveVariant } = useVerticalSystemContext();
  const [selectedVariant, setSelectedVariant] = useState<VerticalSystemVariant | undefined>();
  const activeItem = activeTabItem?.items.find(item => item.variant === selectedVariant);
  const rootRef = useRef<HTMLDivElement>(null);
  useLinkArrowAnimation(rootRef, styles.tabItemLink);
  useVerticalSystemCarouselScroll(rootRef);

  function onSelectVariant(variant?: VerticalSystemVariant) {
    setActiveVariant(variant);
    setSelectedVariant(variant);
  }

  return (
    <div className={styles.carousel} ref={rootRef}>
      {tabItems.map(tabItem => {
        const isTabActive = tabItem.id === activeTabItem?.id;

        return (
          <VerticalSystemTabPanel
            key={tabItem.id}
            isListScrollable
            isTabActive={isTabActive}
            styles={styles}
            tabItem={tabItem}
            onSelectVariant={onSelectVariant}
            {...props}
          />
        );
      })}
      <VerticalSystemModal activeItem={activeItem} onRequestClose={onSelectVariant} />
    </div>
  );
};
